var map = {
	"./a/flowers.png": 40206,
	"./a/tasterkit.png": 42333,
	"./b/hardwax.png": 95450,
	"./c/softwax.png": 10411,
	"./d/special.png": 9657,
	"./e/tools.png": 84203,
	"./g/calendar.png": 41724,
	"./g/materialbox.png": 77261,
	"./g/newmaterialbox.png": 91524,
	"./j/tasterkit.png": 33839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76736;